import type { ListBuilderConfiguration } from '../types';

/**
 * Login History list configuration
 * Converted from JSON to TypeScript for type safety
 */
export const LOGIN_HISTORY_LIST_CONFIG: ListBuilderConfiguration = {
	lists: [
		{
			id: 'login-history-crm-users',
			cacheTTL: 600000,
			name: 'CRM Users',
			type: 'default',
			active: true,
			sortOrder: 0,
			columns: [
				{
					id: 'date',
					headers: [
						{
							id: 'date-header',
							text: 'Date',
						},
					],
					fields: [
						{
							id: 'date-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'date',
									objectTable: 'login_history',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
								formatOptions: {
									dateFormat: 'datetime-short',
								},
								allowTextWrap: false,
							},
							displayStyle: 'date',
						},
					],
					sortable: true,
					sortFields: [
						{
							objectTable: 'login_history',
							fieldName: 'date',
							direction: 'DESC',
						},
					],
					width: 160,
					minWidth: 160,
					maxWidth: 160,
					verticalAlignment: 'top',
				},
				{
					id: 'user',
					headers: [
						{
							id: 'user-header',
							text: 'User',
						},
						{
							id: 'user-break',
							text: '',
							displayStyle: 'line_break',
						},
						{
							id: 'user-email-header',
							text: 'Email',
						},
					],
					fields: [
						{
							id: 'user-name-field',
							dataConfig: {
								type: 'template',
								template: '{user.firstName} {user.lastName}',
								templateFields: [],
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
						{
							id: 'line-break-user',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'line_break',
						},
						{
							id: 'user-email-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'user.email',
									objectTable: 'login_history',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'theme',
									themeColor: 'textSecondary',
								},
							},
							displayStyle: 'text',
						},
					],
					sortable: false,
					widthConfig: {
						mode: 'flexible',
						preset: 'large',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'device-location',
					headers: [
						{
							id: 'device-header',
							text: 'Device',
						},
						{
							id: 'device-break',
							text: '',
							displayStyle: 'line_break',
						},
						{
							id: 'ip-header',
							text: 'IP',
						},
					],
					fields: [
						{
							id: 'device-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'parsedUserAgent.summary',
									objectTable: 'login_history',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
						{
							id: 'line-break-device',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'line_break',
						},
						{
							id: 'ip-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'ip',
									objectTable: 'login_history',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'theme',
									themeColor: 'textSecondary',
								},
							},
							displayStyle: 'text',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'medium',
					},
					verticalAlignment: 'top',
				},
			],
			filterRules: {
				loginHistoryUserType: {
					defaultValue: [
						{
							id: 'crm',
							label: 'CRM',
						},
					],
				},
			},
		},
		{
			id: 'login-history-ecommerce-users',
			cacheTTL: 600000,
			name: 'Ecommerce Users',
			type: 'default',
			active: true,
			sortOrder: 1,
			columns: [
				{
					id: 'date',
					headers: [
						{
							id: 'date-header',
							text: 'Date',
						},
					],
					fields: [
						{
							id: 'date-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'date',
									objectTable: 'login_history',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
								formatOptions: {
									dateFormat: 'datetime-short',
								},
								allowTextWrap: false,
							},
							displayStyle: 'date',
						},
					],
					sortable: true,
					sortFields: [
						{
							objectTable: 'login_history',
							fieldName: 'date',
							direction: 'DESC',
						},
					],
					width: 160,
					minWidth: 160,
					maxWidth: 160,
					verticalAlignment: 'top',
				},
				{
					id: 'user',
					headers: [
						{
							id: 'user-header',
							text: 'User',
						},
						{
							id: 'user-break',
							text: '',
							displayStyle: 'line_break',
						},
						{
							id: 'user-email-header',
							text: 'Email',
						},
					],
					fields: [
						{
							id: 'user-name-field',
							dataConfig: {
								type: 'template',
								template: '{user.firstName} {user.lastName}',
								templateFields: [],
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
						{
							id: 'line-break-user',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'line_break',
						},
						{
							id: 'user-email-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'user.email',
									objectTable: 'login_history',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'theme',
									themeColor: 'textSecondary',
								},
							},
							displayStyle: 'text',
						},
					],
					sortable: false,
					widthConfig: {
						mode: 'flexible',
						preset: 'large',
					},
					verticalAlignment: 'top',
				},
				{
					id: 'device-location',
					headers: [
						{
							id: 'device-header',
							text: 'Device',
						},
						{
							id: 'device-break',
							text: '',
							displayStyle: 'line_break',
						},
						{
							id: 'ip-header',
							text: 'IP',
						},
					],
					fields: [
						{
							id: 'device-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'parsedUserAgent.summary',
									objectTable: 'login_history',
								},
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'text',
						},
						{
							id: 'line-break-device',
							dataConfig: {
								type: 'custom_text',
								customText: '',
							},
							styleConfig: {
								size: 'md',
								colorRule: {
									type: 'default',
								},
							},
							displayStyle: 'line_break',
						},
						{
							id: 'ip-field',
							dataConfig: {
								type: 'field',
								field: {
									fieldName: 'ip',
									objectTable: 'login_history',
								},
							},
							styleConfig: {
								size: 'sm',
								colorRule: {
									type: 'theme',
									themeColor: 'textSecondary',
								},
							},
							displayStyle: 'text',
						},
					],
					widthConfig: {
						mode: 'flexible',
						preset: 'medium',
					},
					verticalAlignment: 'top',
				},
			],
			filterRules: {
				loginHistoryUserType: {
					defaultValue: [
						{
							id: 'ecommerce',
							label: 'Ecommerce',
						},
					],
				},
			},
		},
	],
	paging: {
		defaultPageSize: 20,
		pageSizeOptions: [10, 20, 50, 100],
	},
	filters: {
		activeFilters: ['loginHistorySearch', 'loginHistoryDateRange'],
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/settings/login-history',
			objectLabel: 'Login History',
			objectTable: 'login_history',
			selectedFields: [
				{ fieldName: 'date', fieldLabel: 'Date' },
				{ fieldName: 'user.firstName', fieldLabel: 'First Name' },
				{ fieldName: 'user.lastName', fieldLabel: 'Last Name' },
				{ fieldName: 'user.email', fieldLabel: 'Email' },
				{ fieldName: 'ip', fieldLabel: 'IP Address' },
				{ fieldName: 'authMethod', fieldLabel: 'Auth Method' },
				{ fieldName: 'status', fieldLabel: 'Status' },
				{ fieldName: 'parsedUserAgent.summary', fieldLabel: 'Device' },
			],
		},
	],
};
